/**
 * Converts a US phone number to E.164 format
 * Strictly assumes US phone numbers only. Handles various input formats:
 * - (415) 555-2671 -> +14155552671
 * - 415-555-2671 -> +14155552671
 * - 14155552671 -> +14155552671
 * - +14155552671 -> +14155552671 (already E164)
 */
export const toUSE164 = (
    phoneNumber: string | null | undefined,
): string | null => {
    if (phoneNumber == null) return null;

    /* keep digits only */
    const digits = phoneNumber.replace(/\D/g, '');

    /* already looks like US with country code */
    if (digits.length === 11 && digits.startsWith('1')) {
        return `+${digits}`;
    }

    /* standard US 10-digit number */
    if (digits.length === 10) {
        return `+1${digits}`;
    }

    /* otherwise, can't confidently convert */
    return null;
};
